import validator from 'validator';

export function isProperlyFormattedCompanyId(id: string) {
  /**
   * OA: As long as we use non-valid UUIDs in tests, this function just checks the "geometry" of the id,
   * i.e. that characters and dashes are in correct places.
   */
  const converted = [...id].map(char => (char === '-' ? char : '0')).join('');
  return validator.isUUID(converted);
}
